import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "warning-info-telemed",
      staticClass: "pa-4 warning-info",
      class: { "warning-info_error": _vm.isErrorWarningInfo },
    },
    [
      _c(VExpandTransition, [
        _vm.isErrorWarningInfo
          ? _c("div", { staticClass: "text-body-2 text-error--text" }, [
              _c("div", { staticClass: "mb-4" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("Отметьте, что принимаете условие", _vm.options)
                    ) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c("div", { staticClass: "mr-4 text-body-1 text--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "Принимаю правило онлайн консультации: врач не выпишет рецепт и заключение, он даст только рекомендации",
                    _vm.options
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(VSwitch, {
            staticClass: "pt-0 mt-0 pl-1 mr-n4",
            attrs: {
              color: "primary",
              "data-qa": "warning_info_telemed_switch_input",
              "hide-details": "",
              dense: "",
              inset: "",
            },
            on: {
              change: _vm.handleChangeReadWarningInfo,
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }